import { useEffect } from 'react';

export function useDocumentTitle(title: string, description?: string) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) {
        const previous = meta.getAttribute('content') || '';
        meta.setAttribute('content', description);
        return () => {
          if (previous) meta.setAttribute('content', previous);
        };
      }
    }
    return undefined;
  }, [title, description]);
}